import {useCallback, useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {
  setSelectedPOI,
  setExistingPOI,
  setPointOfInterests,
  setPOI,
  selectSelectedPOI,
  selectExistingPOI,
  selectPointOfInterests,
  selectPOI
} from '../slices/pointOfInterestSlice'
import {useConfig} from './config'
import {useFilterListDetail} from './filterListDetail'
import {selectPermission} from '../slices/permissionSlice'

export const usePointOfInterest = () => {
  const dispatch = useDispatch()
  const selectedPOI = useSelector(selectSelectedPOI)
  const existingPOI = useSelector(selectExistingPOI)
  const pointOfInterests = useSelector(selectPointOfInterests)
  const poi = useSelector(selectPOI)

  const {POIConfig: poiConfig, defaultPOIConfig: defaultPOI} = useConfig() || {}
  const {pointOfInterestFilter} = useFilterListDetail()
  const selectedPermission = useSelector(selectPermission)
  // Set pointOfInterests from config
  useEffect(() => {
    if (poiConfig && Object.keys(poiConfig).length > 0) {
      const tempPointOfInterests = Object.keys(poiConfig).map((poiValue) => ({
        value: poiValue,
        label: poiConfig[poiValue].label,
        enabled: poiConfig[poiValue].enabled,
        poi_id: poiConfig[poiValue].id
      }))
      dispatch(setPointOfInterests(tempPointOfInterests))
    }
  }, [poiConfig, dispatch])

  // Set default POI from config
  useEffect(() => {
    if (defaultPOI) {
      dispatch(setPOI(defaultPOI))
    }
  }, [defaultPOI, dispatch])

  // Set existingPOI based on permission and filters
  useEffect(() => {
    if (selectedPermission) {
      const poiList = selectedPermission?.healthEquityConditionList?.pointOfInterestList || []
      const selectedPOIList = pointOfInterests
        ?.filter((value) => poiList?.includes(value.poi_id))
        .map((value) => ({
          ...value,
          customLabel: pointOfInterestFilter.find((poi) => poi.POI_ID === value.poi_id)?.POI_CUSTOM_NAME || value.title
        }))
      dispatch(setExistingPOI(selectedPOIList))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPermission, pointOfInterests, dispatch])

  const handleSetSelectedPOI = useCallback(
    (value) => {
      dispatch(setSelectedPOI(value))
    },
    [dispatch]
  )

  const handleSetExistingPOI = useCallback(
    (value) => {
      dispatch(setExistingPOI(value))
    },
    [dispatch]
  )

  return {
    selectedPOI,
    setSelectedPOI: handleSetSelectedPOI,
    existingPOI,
    setExistingPOI: handleSetExistingPOI,
    pointOfInterests,
    poi
  }
}
